<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol lg="3">
                <CInput
                  readonly
                  label="Kode Administrator"
                  invalid-feedback="Administrator Code should be filled"
                  required
                  v-model="$v.administratorDetailForm.admin_code.$model"
                  :is-valid="!$v.administratorDetailForm.admin_code.$invalid"
                />
              </CCol>
              <CCol lg="3">
                <CInput
                  label="Deskripsi"
                  invalid-feedback="Description should be filled"
                  v-model="$v.administratorDetailForm.description.$model"
                  :is-valid="!$v.administratorDetailForm.description.$invalid"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <CInput
                  label="Name"
                  invalid-feedback="Name should be filled"
                  required
                  v-model="$v.administratorDetailForm.name.$model"
                  :is-valid="!$v.administratorDetailForm.name.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  label="Email"
                  invalid-feedback="Email should be filled"
                  required
                  v-model="$v.administratorDetailForm.email.$model"
                  :is-valid="!$v.administratorDetailForm.email.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  readonly
                  label="Password"
                  invalid-feedback="Password should be filled"
                  required
                  v-model="$v.administratorDetailForm.password.$model"
                  :is-valid="!$v.administratorDetailForm.password.$invalid"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label for="change_flag">Change Password?</label>
                  <model-select
                    class="form-control"
                    id="change_flag"
                    :options="changeList"
                    v-model="change_flag"
                    placeholder="-- Perlu ganti password? --"
                    @input="changePass"
                  ></model-select>
                </div>
              </CCol>
              <CCol sm="3" v-if="change_flag === '1'">
                <CInput
                  label="Password Baru"
                  invalid-feedback="New Password should be filled"
                  required
                  v-model="$v.administratorDetailForm.new_password.$model"
                  :is-valid="!$v.administratorDetailForm.new_password.$invalid"
                />
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              :disabled="$v.administratorDetailForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";
import { required } from "vuelidate/lib/validators";

export default {
  name: "AdministratorDetail",
  components: { GlobalTable, Loading},
  data() {
    return {
      title: "Administrator Detail",
      items: [],
      administratorDetail: [],
      administratorDetailForm: tableInterfaces.administrator_detail,
      change_flag:"2",
      changeList: [
        { value: "1", text: "Yes" },
        { value: "2", text: "No" },
      ],
      isLoading: false,
      activeTab: 0,
    };
  },
  validations(){
    if(this.change_flag === '2') {
     return {
        administratorDetailForm: {
          admin_code: { required },
          description:{},
          name: { required },
          email: { required },
          password: { required }
        }
     }
    } else {
     return {
        administratorDetailForm: {
          admin_code: { required },
          description:{},
          name: { required },
          email: { required },
          password: { required },
          new_password:{required}
        }
     }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getAdministratorDetail(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    changePass:function(){
      if(this.change_flag === '2'){
        this.administratorDetailForm.new_password = null
      }
    },
    getAdministratorDetail: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/administrator/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.administratorDetailForm = response.data.data;

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        // console.log(this.administratorDetailForm)
        this.axios
        .put("console/administrator/update", this.administratorDetailForm)
        .then((response) => {
          this.showInfoNotification({
            title: "Administrator Update Status",
            message: response.data.message,
          });
        })
        .catch((error) => {
          this.expired(error, "Administrator Update Status");
        })
        .finally(() => {
          this.change_flag = '2';
          this.administratorDetailForm.new_password = null
          
          this.isLoading = false;
          let route = this.$route.path.split("/");
          this.init(route[4]);
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);

    this.loadingRooms = false
    this.messagesLoaded = true
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
